import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  HTTP_CP_GetMortgageDealRepresentativeExample_Request,
  HTTP_CP_GetSmartSearchDealRepresentativeExample_Request,
} from '@api-new/mortgageservice';
import { provideComponentStore } from '@ngrx/component-store';
import { RepresentativeExampleStore } from '@platform/property/components/representative-example/representative-example.store';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'cp-representative-example',
  imports: [SkeletonModule, AsyncPipe],
  templateUrl: './representative-example.component.html',
  styleUrls: ['./representative-example.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideComponentStore(RepresentativeExampleStore)],
})
export class RepresentativeExampleComponent {
  @Input() set representativeExampleRequest(
    request: HTTP_CP_GetMortgageDealRepresentativeExample_Request | HTTP_CP_GetSmartSearchDealRepresentativeExample_Request,
  ) {
    this.componentStore.getRepresentativeExample(request);
  }

  protected readonly isLoading$ = this.componentStore.selectIsLoading$;
  protected readonly representativeExample$ = this.componentStore.selectRepresentativeExample$;

  constructor(private readonly componentStore: RepresentativeExampleStore) {}
}
